import type { AsyncData } from "#app";
import type { IModelResponse } from "~/services/base/dto/base.dto";
import type { IModelGETKnowledgeDocumentRequest, IModelGETKnowledgeDocumentResponse } from "./dto/knowledge-document.dto";


export class KnowledgeDocumentRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService
  }

  async getKnowledgeDocument(params: IModelGETKnowledgeDocumentRequest): Promise<AsyncData<IModelResponse<IModelGETKnowledgeDocumentResponse[]>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/knowledge-document`, this.configService, {
      params,
    });
    return dataResult;
  }

  async getKnowledgeDocumentById(id: string): Promise<AsyncData<IModelResponse<IModelGETKnowledgeDocumentResponse>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/knowledge-document/${id}`, this.configService);
    return dataResult;
  }

  async deleteKnowledgeDocument(id: string | number): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/knowledge-document/${id}`, this.configService, {
      method: 'DELETE'
    });
    return dataResult;
  }
}

